import React from "react";
import { languages } from "../../constants/languages";
import Checkbox from "@material-ui/core/Checkbox";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const SelectFields = props => (
  <Autocomplete
    disabled={props.tournament.scheduleLocked || false}
    size="small"
    multiple
    disableCloseOnSelect
    options={props.options}
    getOptionLabel={option => option.label}
    // getOptionSelected={option =>
    //   props.value.find(v => option.value === v.value) !== undefined
    // }
    onChange={(e, newValue) => {
      props.handleSelectChange(e, newValue);
    }}
    value={props.selectedValue}
    renderInput={params => {
      return (
        <TextField
          {...params}
          variant="standard"
          // placeholder={languages.schedule.allPoulesBrackets}
          label={languages.schedule.selectFields}
          fullWidth
          // InputLabelProps={{
          //   shrink: true
          // }}
        />
      );
    }}
    renderOption={(option, { selected }) => {
      let isSelected = selected;
      if (option.value === "allFields") {
        isSelected = props.selectedValue.find(v => v.value === "allFields")
          ? true
          : false;
      }
      let label = option.label;
      if (option.value === "allFields") {
        label = <b>{option.label}</b>;
      }
      return (
        <React.Fragment>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={isSelected}
          />
          {label}
        </React.Fragment>
      );
    }}
    clearText=""
    closeText=""
    openText=""
    noOptionsText={languages.schedule.noFields}
    onOpen={() => {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        var inputs = document.getElementsByTagName("input");
        for (var i = 0; i < inputs.length; i++) {
          inputs[i].blur();
        }
      }
    }}
  />
);

export default SelectFields;
